export default function ArchivedReportInstancesController() { /* provided only for controllerAs binding */ }
